import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Feepavati = () => {
  const [htmlContent, setHtmlContent] = useState('');
  const [studentDetails, setStudentDetails] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const location = useLocation();
  const language = localStorage.getItem("language");
  const navigate = useNavigate();
  const {
    feeDetails,
    selectedClass,
    schoolDetails,
  } = location.state || {};

  console.log("feeDetails", feeDetails);
  console.log("selectedClass", selectedClass);
  console.log("schoolDetails", schoolDetails);

  // console.log("feeDetails",feeDetails);
  const getBaseFeetype = (feetype) => {
    const lastIndex = feetype.lastIndexOf('-');
    return lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype; // Return the part before the last '-' or the whole feetype if '-' is not found
  };
  const fetchData = async () => {
    const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;

    const studentResponse = await fetch(studentUrl);
    const studentData = await studentResponse.json();

    if (!studentData || Object.keys(studentData).length === 0) {
      console.warn("No student data found for the given udiseNumber.");
      setStudentDetails([]);
      return;
    }

    const studentArray = Object.values(studentData).filter(student => student !== null && (student.isActive === true || student.isActive === undefined));
    setStudentDetails(studentArray);

    generateHTMLReport(studentArray); // Pass the fetched student data to the HTML generation function
  };
  // console.log("studentDetails",studentDetails);

  const filteredFeeDetails = feeDetails ? feeDetails.reduce((acc, fee) => {
    const serialNo = fee.serialNo;

    if (!acc.has(serialNo)) {
      acc.set(serialNo, fee);
    } else {
      const currentFee = acc.get(serialNo);
      // Compare dates to find the latest transaction
      const feeDate = new Date(fee.date);
      const currentDate = new Date(currentFee.date);

      if (feeDate > currentDate) {
        acc.set(serialNo, fee);
      } else if (feeDate.getTime() === currentDate.getTime()) {
        // If dates are equal, pick the one with higher cumulative payment (beforePay)
        if (parseFloat(fee.beforePay || 0) > parseFloat(currentFee.beforePay || 0)) {
          acc.set(serialNo, fee);
        }
      }
    }

    return acc;
  }, new Map()).values() : [];

  const resultArray = Array.from(filteredFeeDetails);
  // console.log("resultArray",resultArray);
  const headings = {
    English: {
      taluka: 'Taluka',
      district: 'District',
      rpheading: 'Fee Report',
      srNo: 'Sr. No',
      studentName: 'Student Name',
      class: 'Class',
      division: 'Division',
      rollNo: 'Roll No',
      feeType: 'Fee Type',
      fee: 'Fee',
      discount: 'Discount (RS)',
      afterDiscountFee: 'After Discount Fee',
      paidFee: 'Paid Fee',
      remainingFee: 'Remaining Fee',
    },
    Marathi: {
      taluka: 'तालुका',
      district: 'जिल्हा',
      rpheading: 'फी अहवाल',
      srNo: 'अनु.क्र.',
      studentName: 'विद्यार्थ्याचे नाव',
      class: 'वर्ग',
      division: 'तुकडी',
      rollNo: 'हजेरी क्र',
      feeType: 'फी प्रकार',
      fee: 'फी',
      discount: 'सवलत (RS)',
      afterDiscountFee: 'सवलतीनंतरची फी',
      paidFee: 'दिलेली फी',
      remainingFee: 'उर्वरित फी',
    },
  };

  // console.log("headings--------------------------",headings);


  const selectedLanguage = language;


  const generateHTMLReport = (studentArray) => {

    // studentArray.forEach(student => {
    //     if (student && student.serialNo) {
    //       console.log("student-------",student);

    //         fullName = student.stdName + " " + student.stdFather + " " + student.stdSurname ; 
    //         rollNoo = student.rollNo || '' ; 
    //     }
    // });

    // Filter students based on the selected class
    const classStudents = studentArray.filter(student => student.currentClass == selectedClass);

    // Determine the common feeType from the feeDetails prop
    let commonFeeType = ' ';
    let commonFeeAmount = ' ';
    if (feeDetails && feeDetails.length > 0) {
      commonFeeType = feeDetails[0].feeType || ' '; // Get the feeType from the first fee detail
      commonFeeAmount = feeDetails[0].amount || ' '; // Get the feeType from the first fee detail
    }

    const tableRows = classStudents.map((student, index) => {
      // console.log("student",student);

      const fee = resultArray.find(fee => fee.serialNo == student.serialNo) || {};
      const fullName = student.stdName + " " + student.stdFather + " " + student.stdSurname;
      const rollNo = student.rollNo || '';
      const division = student.division || '';

      const amount = parseFloat((commonFeeType === "Bus Fee") ? fee.amount || '0' : commonFeeAmount || '0');
      const discountAmount = parseFloat(fee.discountAmount || '0');
      const remainingAmount = parseFloat(fee.remainingAmount || '0');
      const beforePay = parseFloat(fee.beforePay || '0');

      // Calculate after discount fee: original amount - discount
      const afterDiscountFee = amount - discountAmount;

      // Calculate remaining fee: after discount fee - paid amount
      const remainingfee = Math.max(0, afterDiscountFee - beforePay);

      return `
          <tr>
              <td class="sr-no">${index + 1}</td>
              <td class="sr-no">${selectedClass}</td>
              <td class="sr-no">${division}</td>
              <td class="sr-no">${rollNo}</td>
              <td class="sr-no">${fullName}</td>
              <td class="sr-no">${getBaseFeetype(commonFeeType)}</td> 
              <td class="sr-no">${amount}</td>
              <td class="sr-no">${discountAmount}</td>
              <td class="sr-no">${remainingAmount || afterDiscountFee}</td>
              <td class="sr-no">${beforePay}</td>
              <td class="sr-no">${remainingfee}</td>
          </tr>
      `;
    });

    const reportContent = `

  <div  class="report-container">
  ${schoolDetails ? `
              <div class="school-details">
                <h6>${schoolDetails.sansthaName || ''}</h6>
                <h4>${schoolDetails.schoolName || ''}</h4>
                <p>${headings[selectedLanguage].taluka}: ${schoolDetails?.taluka || ' '}, ${headings[selectedLanguage].district}: ${schoolDetails?.jilha || ' '}</p>
                <h2 class="report-title"> ${headings[selectedLanguage].rpheading}</h2>
              </div>
            ` : ''}

      <table>
        <thead>
          <tr>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].srNo}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].class}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].division}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].rollNo}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].studentName}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].feeType}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].fee}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].discount}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].afterDiscountFee}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].paidFee}</th>
            <th class="sr-no" style="background-color: #A31D27; color: white;">${headings[selectedLanguage].remainingFee}</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows.join('')}
        </tbody>
      </table>
    </div>
`;

    setHtmlContent(reportContent);
  };

  const handlePrint = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write(`
      <html>
        <head>
          
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 0px; 
              margin: 0; 
              background-color: #f4f4f4; 
            }
            @page {
                size: A4 Portrait; /* auto is the initial value */
              margin: 3mm; /* this affects the margin in the printer settings */
            }
            .report-container {
              border: 1px solid black;
              padding: 10px;
              margin: 10px auto;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              width: auto;
              background-color: white;
            }
            .school-details {
              text-align: center;
              margin-bottom: 20px;
            }
            .report-title {
              display: block;
              border: 1px solid black;
              background-color: black;
              color: white;
              padding: 5px;
              width: 200px;
              text-align: center;
              margin: 10px auto;
              border-radius:6px;
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin-top: 20px;
              border: 1px solid black; /* Added border to the table */
            }
            th, td { 
              border: 1px solid black; /* Changed border color to black */
              padding: 8px; 
              text-align: center; 
            }
            th { 
              background-color: #A31D27; 
              color: white; 
            }
            .sr-no, .class, .roll-no {
              padding:8px 2px !important; 
            }
            @media print {
              .page-number {
                position: fixed;
                bottom: 0;
                right: 0;
                font-size: 12px;
                margin: 10px;
              }
            }
          </style>
        </head>
        <body>
          ${htmlContent}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };
  return (
    <div className='main-content-of-page'>


      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
        <button
          onClick={handleGoBack}
          style={{
            backgroundColor: '#FFFFFF',
            color: 'black',
            padding: '7px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '20px', // Space between buttons
            border: '1px solid black',
            marginTop: '20px',
            marginLeft: '30px',
          }}
        >
          <i className="fa fa-arrow-left" style={{ fontSize: '22px', marginRight: '8px' }}></i>
          Go Back
        </button>

        <button
          onClick={handlePrint}
          style={{
            backgroundColor: '#A31D27',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '20px',
          }}
        >
          Print Report
        </button>
      </div>
      <style jsx>{`
   .report-title {
              display: block;
              border: 1px solid black;
              background-color: black;
              color: white;
              padding: 4px;
              width: 200px;
              text-align: center;
              margin: 10px auto;
              border-radius:6px;
            }
             table { 
              width: 100%; 
              border-collapse: collapse; 
              margin-top: 20px;
              border: 1px solid black; /* Added border to the table */
            }
            th, td { 
              border: 1px solid black; /* Changed border color to black */
              padding: 8px; 
              text-align: center; 
            }
            th { 
              background-color: #A31D27; 
              color: white; 
            }
  `}</style>
      <div style={{
        border: '2px solid black',
        padding: '20px',
        margin: '20px auto',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        width: '1000px', textAlign: 'center'
      }}>
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div>
    </div>
  );
}

export default Feepavati;